<template>
  <blank-card>
    <TopicSearch />
    <div class="main">
      <div class="main-bd" style="">
        <el-row>
          <el-col :span="16" :md="16" :sm="24" :xs="24">
            <TopicHeader
              v-if="topicDetailObj.topicSentenceId"
              :topicDetail="topicDetailObj"
            />
            <TopicSource
              v-if="sourceInfo.paperTitle"
              :sourceInfo="sourceInfo"
            />
            <TopicVerify
              v-if="similarArticleList.length > 0"
              :similarArticleList="similarArticleList"
              :similarTotal="similarTotal"
              :sameTotal="sameTotal"
            />
          </el-col>
          <el-col :span="6" :md="6" :sm="16" :xs="24">
            <TopicRelated
              v-if="similarSentenceList.length > 0"
              :similarSentenceList="similarSentenceList"
              :paperId="sourceInfo.paperId"
            />
          </el-col>
        </el-row>
      </div>
    </div>
  </blank-card>
</template>

<script lang="ts">
import {
  getTopicDetail,
  getTopicSimilar,
  topicDetail,
  topicSimilar,
  sourceInfo,
  similarArticleInfo,
  similarSentenceInfo,
} from '@/api/assist'
import { useRoute } from 'vue-router'
import router from '@/router'
import { defineComponent, onMounted, ref } from 'vue'
import BlankCard from '@/components/blankCard/index.vue'
import TopicSearch from './search/index.vue'
import TopicRelated from '@/components/assist/detail/related.vue'
import TopicHeader from '@/components/assist/detail/header.vue'
import TopicSource from '@/components/assist/detail/source.vue'
import TopicVerify from '@/components/assist/detail/verify.vue'

export default defineComponent({
  components: {
    BlankCard,
    TopicSearch,
    TopicRelated,
    TopicHeader,
    TopicSource,
    TopicVerify,
  },
  setup() {
    const topicSentenceId = ref('')
    const route = useRoute()
    const topicDetailObj = ref({} as topicDetail)
    const topicSimilarObj = ref({} as topicSimilar)
    const sourceInfo = ref({} as sourceInfo)
    const similarArticleList = ref([] as similarArticleInfo[])
    const similarSentenceList = ref([] as similarSentenceInfo[])
    const sameTotal = ref(0)
    const similarTotal = ref(0)

    const topicDetailLoad = async (sentenceId: string) => {
      const res = await getTopicDetail(sentenceId)
      if (res.status === 200) {
        topicDetailObj.value = res.data
        sourceInfo.value = topicDetailObj.value.sentenceSourceInfoEntity
        const length = sourceInfo.value.topicParagraph.length
        const posStart = sourceInfo.value.hightLightPosition.start
        const posEnd = sourceInfo.value.hightLightPosition.end

        const start = sourceInfo.value.topicParagraph.substring(0, posStart - 1)
        const middle = sourceInfo.value.topicParagraph.substring(
          posStart - 1,
          posEnd - 1
        )
        const end = sourceInfo.value.topicParagraph.substring(
          posEnd - 1,
          length - 1
        )
        const target = `${start}<span style='font-weight:700'>${middle}</span>${end}`
        sourceInfo.value.topicParagraph = target
      }
    }
    const topicSimilarLoad = async (sentenceId: string) => {
      const res = await getTopicSimilar(sentenceId)
      if (res.status === 200) {
        topicSimilarObj.value = res.data
        similarArticleList.value = topicSimilarObj.value.similarArticleInfos
        similarSentenceList.value = topicSimilarObj.value.similarSentenceInfos
        sameTotal.value = topicSimilarObj.value.sameTotal
        similarTotal.value = topicSimilarObj.value.similarTotal
      }
    }
    onMounted(() => {
      topicSentenceId.value = route.params.query as string
      if (topicSentenceId.value) {
        topicDetailLoad(topicSentenceId.value)
        topicSimilarLoad(topicSentenceId.value)
      } else {
        router.push('/assist')
      }
    })
    return {
      topicSentenceId,
      topicDetailObj,
      topicSimilarObj,
      sourceInfo,
      similarArticleList,
      similarSentenceList,
      sameTotal,
      similarTotal,
    }
  },
})
</script>

<style lang="less" scoped>
.main {
  display: flex;
  justify-content: center;
  padding-bottom: 100px;
  margin-top: 65px;
  padding-left: 50px;
  .main-bd {
    width: 1200px;
  }
}
.mobile-viewport {
  .main {
    margin-top: 40px;
    padding-left: 15px;
    justify-content: inherit;
    .main-bd {
      width: 100%;
    }
  }
}
</style>
